<template>
	<div class="list-container column">
		<div class="title">
			 {{ $t('questionlist.title') }} {{ questionGroup ? ' - ' + questionGroup.name : '' }}
		</div>
		<div class="panel-list-header">
			<div class="panel-header-item">
				{{ $t('questionlist.column_name') }}
			</div>
			<div class="panel-filler" />
		</div>
		<div
			class="panel-list"
			v-for="question in questions"
			:key="question.id"
			@click.stop="onEdit(question)"
		>
			<div class="panel-list-item">
				{{ question.name || question.description }}
			</div>
			<div
				v-if="$isAllowedTo('questions_edit')"
				class="list-button"
				@click.stop="onEdit(question)"
			>
				<i class="fas fa-edit"></i>
			</div>
			<!-- Disabled delete until its verified in api
        <div class="list-button" @click.stop="onDelete(question)">
          <i class="fas fa-trash-alt"></i>
        </div>
        -->
		</div>
		<div class="panel-block block" v-if="questions.length == 0">
			<div class="panel-list no-hover">
				<p class="panel-list-item">{{ $t('questionlist.no_questions') }}</p>
			</div>
		</div>
		<Pagination
			v-if="questions.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		Pagination
	},
	props: {
		questions: Array,
		questionGroup: Object
	},
	computed: {
		...mapGetters('questionStore', ['pagination'])
	},
	methods: {
		...mapActions('questionStore', ['setCurrentPage', 'setPageSize']),
		onDelete(question) {
			this.$emit('delete', question);
		},
		onEdit(question) {
			this.$emit('edit', question);
		},
		onAdd() {
			this.$emit('add');
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		}
	}
};
</script>
